import MentengStudio1 from '../../../Media/Ruko Paramount/Menteng Studio Loft/Menteng Studio Loft (1).webp'
import MentengStudio2 from '../../../Media/Ruko Paramount/Menteng Studio Loft/Menteng Studio Loft (2).webp'
import MentengStudio3 from '../../../Media/Ruko Paramount/Menteng Studio Loft/Menteng Studio Loft (3).webp'
import MentengStudio4 from '../../../Media/Ruko Paramount/Menteng Studio Loft/Menteng Studio Loft (4).webp'

const MentengStudioimages =[
MentengStudio1,MentengStudio2,MentengStudio3,MentengStudio4
]

export default MentengStudioimages;
